import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import useRefreshToken from "./useRefreshToken";
import useAuth from "./useAuth";
import styled from "styled-components";
const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 70vh;
	gap: 20px;
`;
const LoadingContainer = styled.div`
	height: 15px;
	width: 80%;
	background-color: gray;
`;
const Progress = styled.div`
	height: 100%;
	width: ${(props) => `${props.prog}%`};
	background-color: crimson;
`;

const PersistLogin = () => {
	const [isLoading, setIsLoading] = useState(true);
	const refresh = useRefreshToken();
	const [prog, setProg] = useState(0);
	const { auth } = useAuth();
	const navigate = useNavigate();
	const location = useLocation();
	useEffect(() => {
		let isMounted = true;

		const verifyRefreshToken = async () => {
			try {
				await refresh();
			} catch (err) {
				console.error(err);
				if (err.code === "ERR_NETWORK")
					navigate("/", { state: { from: location }, replace: true });
				else if (
					err.response.status === 401 ||
					err.response.status === 403
				);
				navigate("/", { state: { from: location }, replace: true });
			} finally {
				isMounted && setIsLoading(false);
			}
		};

		// persist added here AFTER tutorial video
		// Avoids unwanted call to verifyRefreshToken
		!auth?.accessToken ? verifyRefreshToken() : setIsLoading(false);

		return () => (isMounted = false);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	useEffect(() => {
		const interval = setInterval(() => {
			setProg((prev) => prev + 1);
			if (prog === 100) setProg(0);
		}, 1000);

		clearInterval(() => interval);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			{isLoading ? (
				<Container>
					{" "}
					<img
						src="/sproxillogo.png"
						alt=""
						style={{ width: "110px" }}
					/>
					<LoadingContainer>
						<Progress prog={prog} />
					</LoadingContainer>
				</Container>
			) : (
				<Outlet />
			)}
		</>
	);
};

export default PersistLogin;
